import { render, staticRenderFns } from "./assurance_view.vue?vue&type=template&id=31e8ca42&scoped=true&"
import script from "./assurance_view.vue?vue&type=script&lang=js&"
export * from "./assurance_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e8ca42",
  null
  
)

export default component.exports